import * as api from '../api';
import { 
    FETCH_RESOURCES,
    FETCH_RESOURCES_BY_GROUP,
    FETCH_RESOURCE_CATEGORIES,
    CREATE_RESOURCE 
} from '../constants/actionTypes';

export const getResources = () => async (dispatch) => {
    try {
        const { data } = await api.fetchResources();
        dispatch({ type: FETCH_RESOURCES, payload: data });
    } catch (error) {
        console.error('Error fetching resources:', error.response?.data || error.message);
        dispatch({ type: FETCH_RESOURCES, payload: [] });
    }
};

export const getResourcesByGroup = (groupId) => async (dispatch) => {
    try {
        const { data } = await api.fetchResourcesByGroup(groupId);
        dispatch({ type: FETCH_RESOURCES_BY_GROUP, payload: data });
    } catch (error) {
        console.error('Error fetching group resources:', error.response?.data || error.message);
        dispatch({ type: FETCH_RESOURCES_BY_GROUP, payload: [] });
    }
};

export const getResourceCategories = () => async (dispatch) => {
    try {
        const { data } = await api.fetchResourceCategories();
        dispatch({ type: FETCH_RESOURCE_CATEGORIES, payload: data });
    } catch (error) {
        console.error('Error fetching resource categories:', error.response?.data || error.message);
        dispatch({ type: FETCH_RESOURCE_CATEGORIES, payload: [] });
    }
};

export const createResource = (resource) => async (dispatch) => {
    try {
        const { data } = await api.createResource(resource);
        dispatch({ type: CREATE_RESOURCE, payload: data });
    } catch (error) {
        console.error('Error creating resource:', error.response?.data || error.message);
    }
}; 